import { type AnyRoute, createRoute } from "@tanstack/react-router";
import { lazy } from "react";

// Lazily loaded — the pricing table is a secondary surface, not part of the
// /chat landing, so it ships as its own chunk.
const PricingPage = lazy(() =>
  import("../components/PricingPage").then((m) => ({ default: m.PricingPage })),
);

/** Pricing route — composed into the app shell layout in `app/router.tsx`. */
export function createPricingRoute<TParent extends AnyRoute>(parent: TParent) {
  return createRoute({ getParentRoute: () => parent, path: "/pricing", component: PricingPage });
}
